import { Avatar } from '@scouts/ui'

import { accountantImageUrl } from '@/domain/accountant'
import { useAccountant } from '@/store/accountant'

import supportImage from '@/assets/images/default-support.png'

interface AccountantAvatarProps {
    width?: string
    tabletWidth?: string
}

export const AccountantAvatar = ({ width, tabletWidth }: AccountantAvatarProps) => {
    const { accountant, isFetching } = useAccountant()

    if (isFetching) return null

    return (
        <Avatar
            width={width}
            tabletWidth={tabletWidth}
            src={accountant ? accountantImageUrl(accountant.id) : supportImage}
        />
    )
}
